import { useState } from 'react';
import { siteInfo } from '@/mocks/site';
import SchemaOrg from '@/components/base/SchemaOrg';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqSchema = {
    mainEntity: siteInfo.faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <section className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
      <SchemaOrg type="FAQPage" data={faqSchema} />
      <div className="max-w-[800px] mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-800">常见问题</h2>
          <p className="text-sm text-foreground-500 mt-2">关于可游漫画网，您可能想了解的问题</p>
        </div>

        <div className="space-y-3">
          {siteInfo.faqs.map((faq, index) => (
            <div
              key={index}
              className="rounded-xl bg-white border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
              >
                <h3 className="text-sm md:text-base font-medium text-foreground-800 pr-4">
                  {faq.question}
                </h3>
                <i
                  className={`ri-arrow-down-s-line text-lg text-foreground-400 transition-transform duration-300 flex-shrink-0 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 pb-4' : 'max-h-0'
                }`}
              >
                <p className="px-5 text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}